var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.deleteAccountShow,
          expression: "deleteAccountShow"
        }
      ],
      staticClass: "popup"
    },
    [
      _c(
        "div",
        {
          staticClass: "content",
          style: { height: _vm.getHeight() },
          attrs: { id: "deleteAccount" }
        },
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\r\n            " +
                _vm._s(_vm.$t("language.popup.personalCenter.deleteAccount")) +
                "\r\n            "
            ),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  return _vm.closePage()
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "delete-Account-content" }, [
            !_vm.user.loginType ||
            _vm.user.loginType == "sub" ||
            _vm.isActiveLoginType(_vm.user.loginType)
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.password,
                      expression: "password"
                    }
                  ],
                  staticClass: "delete-Account-input",
                  attrs: {
                    type: "password",
                    placeholder: _vm.$t(
                      "language.popup.personalCenter.enterPassWord"
                    )
                  },
                  domProps: { value: _vm.password },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.password = $event.target.value
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "advise-box" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.note,
                    expression: "note"
                  }
                ],
                attrs: {
                  placeholder: _vm.$t("language.popup.personalCenter.note")
                },
                domProps: { value: _vm.note },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.note = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "done-button",
                on: {
                  click: function($event) {
                    return _vm.deleteDone()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("language.common.done")))]
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-748d9100", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-748d9100","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/personal_center_popups/delete_account_popup.vue
// module id = null
// module chunks = 